import { EUROPEAN_GDPR_COUNTRIES } from '@lemonade-hq/lemonation';

var isLocationInGDPR = function(param) {
    var region = param.region, countryIso = param.countryIso;
    if (region == null && countryIso == null) {
        return false;
    }
    var upperCaseRegion = region === null || region === void 0 ? void 0 : region.toUpperCase();
    var upperCaseCountryIso = countryIso === null || countryIso === void 0 ? void 0 : countryIso.toUpperCase();
    var isLocationInGDPRRegion = upperCaseRegion != null ? EUROPEAN_GDPR_COUNTRIES.includes(upperCaseRegion) : false;
    var isLocationInGDPRCountry = upperCaseCountryIso != null ? EUROPEAN_GDPR_COUNTRIES.includes(upperCaseCountryIso) : false;
    return isLocationInGDPRRegion || isLocationInGDPRCountry;
};

export { isLocationInGDPR };
